/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.contentEditorModule')
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  .controller('AttachedFileBlockController', ['$scope', 'Restangular', AttachedFileBlockController]);

/**
 * Controller for Attached File Blocks.
 */
function AttachedFileBlockController($scope, Restangular) {

  this.autoSaveOptions = {
    restId: $scope.contentBlockCtrl.page.unit.id,
    customSave: function customSave() {
      const patch = {
        title: $scope.contentBlockCtrl.contentBlock.title
      };
      return Restangular.one('units', $scope.contentBlockCtrl.page.unit.id)
        .one('attachedfileblock', $scope.contentBlockCtrl.contentBlock.id).patch(patch);
    }
  };
}
